








import { Component, Mixins, Prop } from "vue-property-decorator";
import { IFreeInputableWrappedObject } from "../objects/IFreeInputableWrappedObject";
import FreeInputtableObjectMenu from "./FreeInputtableObjectMenu.vue";

@Component({
  components: {
    FreeInputtableObjectMenu,
  }
})
export default class RollObjectMenu extends Mixins() {
  @Prop()
  source: IFreeInputableWrappedObject;

  @Prop()
  isInputMethodSelectable: boolean;

  get unselectedButtonConfiguration(): { class: string, label: string, description: string } {
    return {
      class: "roll-object-menu-deselected",
      label: "クリック選択",
      description: "入力方法をクリック選択に切り替えます。",
    };
  }
}
